export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";